import * as Yup from "yup";

import { ChangeEvent, useEffect, useState } from "react";
import { ChipInput, CustomSelect, TextInput } from "../../components";

import { useFormik } from "formik";

const AddStinger = () => {
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      pincode: "",
      age: "",
      gender: "",
      onboardingDate: "",
      validity: "",
      organisation: "",
      business: "",
      team: "",
      threads: [],
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(3, "Title should be more than 3 charcters")
        .max(100, "title should be less than 100 characters")
        .required("This field is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
        .required("Phone number is required"),
      pincode: Yup.string()
        .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
        .required("Pincode is required"),
      age: Yup.number().min(18).max(100).required("Age is required"),
      gender: Yup.string().required("Gender is required"),
      business: Yup.string().required("This field is required"),
      organisation: Yup.string().required("This field is required"),
      team: Yup.string().required("This field is required"),
    }),
    onSubmit: (values) => {
      console.log(values);
    },
  });
  return (
    <div className="container">
      <div className="d-flex justify-content-between p-3 py-2 align-items-center bg-white sticky-top top-0 shadow-sm mb-3">
        <div className=" d-flex justify-content-center align-items-center gap-2">
          <i className="bi bi-arrow-left pointer"></i>
          <span>Add Stinger</span>
        </div>
      </div>
      <div className="py-2">
        <div className="row">
          <div className="col col-6">
            <TextInput
              showRequired
              name="name"
              label="Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              characterLimit={10}
              onBlur={formik.handleBlur}
              error={formik.errors.name}
              touched={formik.touched.name}
            />
          </div>
          <div className="col col-6">
            <TextInput
              showRequired
              name="email"
              label="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              characterLimit={100}
              onBlur={formik.handleBlur}
              error={formik.errors.email}
              touched={formik.touched.email}
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-6">
            <TextInput
              showRequired
              name="phone"
              label="Phone"
              value={formik.values.phone}
              onChange={formik.handleChange}
              characterLimit={10}
              onBlur={formik.handleBlur}
              error={formik.errors.phone}
              touched={formik.touched.phone}
            />
          </div>
          <div className="col col-6">
            <TextInput
              showRequired
              name="pincode"
              label="Pincode"
              value={formik.values.pincode}
              onChange={formik.handleChange}
              characterLimit={6}
              onBlur={formik.handleBlur}
              error={formik.errors.pincode}
              touched={formik.touched.pincode}
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-6">
            <TextInput
              showRequired
              name="age"
              type="number"
              label="Age"
              value={formik.values.age}
              onChange={formik.handleChange}
              characterLimit={100}
              onBlur={formik.handleBlur}
              error={formik.errors.age}
              touched={formik.touched.age}
            />
          </div>
          <div className="col col-6">
            <CustomSelect
              showRequired
              label="Gender"
              value={formik.values.gender}
              options={[
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Other", value: "other" },
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-4">
            <CustomSelect
              label="Organisation"
              value={formik.values.organisation}
              options={[
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Other", value: "other" },
              ]}
              showRequired
            />
          </div>
          <div className="col col-4">
            <CustomSelect
              label="Business"
              value={formik.values.business}
              options={[
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Other", value: "other" },
              ]}
            />
          </div>
          <div className="col col-4">
            <CustomSelect
              label="Team/Property"
              value={formik.values.team}
              options={[
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Other", value: "other" },
              ]}
            />
          </div>
        </div>

        <div className="row">
          <ChipInput
            label="Threads"
            value={formik.values.threads}
            handleChipChange={(chip, action) => {
              if (action === "add") {
                formik.setFieldValue("threads", [
                  ...new Set([...formik.values.threads, chip]),
                ]);
              } else if (action === "remove") {
                formik.setFieldValue(
                  "threads",
                  formik.values.threads.filter((t) => t !== chip)
                );
              } else if (action === "clear") {
                formik.setFieldValue("threads", []);
              }
            }}
          />
        </div>
        <div className="row justify-content-center">
          <div className="form-check col col-4">
            <input
              className="form-check-input"
              type="checkbox"
              checked={isTermsAccepted}
              id="flexCheckDefault"
              onClick={() => setIsTermsAccepted((state) => !state)}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              I Accept The above Details are true
            </label>
          </div>
        </div>
        <div className="border-top p-3 mt-5 d-flex justify-content-end">
          <button
            disabled={!isTermsAccepted || !formik.dirty}
            className="btn btn-primary"
          >
            CREATE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddStinger;
